var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.color,style:(!_vm.vertical ? 'width: 100%; height: 1px; min-height: 1px' : 'height: 100%; width: 1px; min-width: 1px')})}
var staticRenderFns = []

export { render, staticRenderFns }